// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__7O524","dragIcon":"Choice_dragIcon__1JL0A","left":"Choice_left__1GhoR","input":"Choice_input__R9Inh"};